import React from 'react';
import { CostSavingProps } from './CostSavingProps';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination, Navigation } from 'swiper/modules';
import './CostSaving.css';

interface ImageSliderProps {
  savingsData: CostSavingProps[]; // Array of all readings from the API
}

const ImageSlider: React.FC<ImageSliderProps> = ({ savingsData }) => {

  return (
    <div className="h-screen w-full">
      <Swiper
        modules={[Pagination, Navigation]}
        pagination={{ clickable: true }}
        navigation
        //className="h-full"
      >
        {savingsData.map((item, index) => (
          <SwiperSlide key={index}>
            {/* <div className="flex flex-col h-full">
               <div className="p-4 bg-white shadow text-center">
                <h2 className="text-3xl font-semibold">{item.title}</h2>
              </div> 
              <div className="flex flex-1 overflow-hidden">*/}
              <div className="imageprops" style={{ textAlign: 'center' }}>
                  <img src={item.src} alt={"Cost Savings"} />
                </div>
                {/* <div className="w-1/3 bg-white p-6 overflow-y-auto">
                  <p className="text-gray-800 whitespace-pre-wrap text-base">{item.notes}</p>
                </div> 
              </div>
            </div>*/}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default ImageSlider;